// extracted by mini-css-extract-plugin
export default {"item":"ToDoCircleItem_item__cZRyc","emoji":"ToDoCircleItem_emoji__btS8q"};